import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  computed,
  inject,
  input,
  signal,
  viewChild,
  viewChildren,
  OnInit,
} from '@angular/core';
import { APIService } from 'src/app/services/APIService/api.service';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { CommonModule } from '@angular/common';
import { ClarityModule, ClrForm } from '@clr/angular';
import { BasicStoreService } from 'src/app/services/BasicStore/basic-store.service';
import { Row } from 'src/app/models/ui/table/row';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { Table } from 'src/app/models/ui/table/table';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BackendLocaleDatePipe } from 'src/app/pipes/get-locale-date.pipe';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import dayjs from 'dayjs';
import { ToastService } from 'src/app/services/toast.service';
import { FILTER_TABLE_STORE, provideFilterStore } from 'src/app/shared/stores/filter-table.store';
import { ColumnFilterComponent } from '../../_components/filter/column-filter/column-filter.component';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { IconDgCellComponent } from '../../_components/_shared/datagrid-cell/icon-dg-cell.component';
import { OverlayService } from 'src/app/services/Overlay/overlay.service';
import { ObjTypePipe as objtype } from 'src/app/pipes/objtype.pipe';
import {
  SpezColumnType,
  SpezPointType,
  SpezRowType,
} from '../../_components/_overlays/spezifikationsdialog/spezifikationsdialog.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-projektdialog',
  templateUrl: './projektdialog.component.html',
  styleUrls: ['./projektdialog.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    MrTranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    TablePrettyPrintPipe,
    IconDgCellComponent,
    BackendLocaleDatePipe,
    HideIDColumnsPipe,
    ColumnFilterComponent,
  ],
  providers: [provideFilterStore()],
})
export class ProjektDialogComponent implements OnInit {
  private toastr = inject(ToastService);
  private mrTranslate = inject(MrTranslatePipe);
  private apiservice = inject(APIService);
  authService = inject(AuthService);
  protected localeDate = inject(BackendLocaleDatePipe);
  private overlayService = inject(OverlayService);

  showAnlSelection: boolean = false;
  showMangSelection: boolean = false;
  prjActive: boolean = false;
  anlActive: boolean = false;
  histActive: boolean = false;

  years: number[];

  public closedialog = new BehaviorSubject(false);
  stammdaten: Table = { rows: [], columns: [] };
  history: Table = { rows: [], columns: [] };
  anlSelected: any;
  startmeter: number;
  endmeter: number;

  sBez: string;
  limitVon: number = 10000;
  limitBis: number = 8640000000000000; //Maximales Datum, um nicht die Validierung zu triggern
  anlSel: any = [];
  verantwortliche: string[] = [];
  kostenstellen: string[] = [];
  dataRefresh: EventEmitter<any>;
  spezReturnEmit: EventEmitter<any> = new EventEmitter();
  protected readonly projID = signal<number>(undefined);
  protected readonly parentID = signal<number>(undefined);
  protected readonly mode = signal<'new' | 'newSub' | 'open'>(undefined);
  private readonly clrForm = viewChild(ClrForm);
  protected readonly filterStore = inject(FILTER_TABLE_STORE);
  private readonly columnFilters = viewChildren(ColumnFilterComponent);
  protected readonly anlagen = signal<Table>(undefined);
  protected readonly maengel = signal<Table>(undefined);

  protected readonly filteredRows = this.filterStore.filteredRows;
  protected neuProjektFormGroup = new FormGroup({
    titel: new FormControl<string>('', [Validators.required]),
    verantwortlich: new FormControl<string>('', [Validators.required]),
    kostenstelle: new FormControl<string>(''),
    projektstatus: new FormControl<number>(1, [Validators.required]),
    projektbeginn: new FormControl<string>(BackendLocaleDatePipe.today, [Validators.required]),
    projektende: new FormControl<string>(BackendLocaleDatePipe.today, [Validators.required]),
    projektsumme: new FormControl<number>(0),
    kurztext: new FormControl<string>('', [Validators.required]),
    langtext: new FormControl<string>(''),
    bemerkung: new FormControl<string>(''),
    diagrammfarbe: new FormControl<string>(''),
    erledigt: new FormControl<boolean>(false),
    datum: new FormControl<string>(BackendLocaleDatePipe.today),
    lieferant: new FormControl<string>(''),
    kosten: new FormControl<number>(0),
    ID: new FormControl<number>(0),
    parentID: new FormControl<number>(0),
    anlagen: new FormControl<any>(undefined),
    maengel: new FormControl<any>(undefined),
  });

  projektStatusLst = [
    { ID: 1, Bezeichnung: 'PLAN - Planung' },
    { ID: 2, Bezeichnung: 'PGEN - Plangenehmigung' },
    { ID: 3, Bezeichnung: 'BAU - Baudurchführung' },
    { ID: 4, Bezeichnung: 'ABNA - Bauabnahme' },
    { ID: 5, Bezeichnung: 'ABSL - Bau Abgeschlossen' },
  ];

  protected selected = signal<Row[]>([]);
  protected readonly maengelselected = signal<Row[]>([]);

  constructor() {
    this.filterStore.registerFilters(this.columnFilters);
    this.filterStore.registerTable(this.anlagen);

    this.spezReturnEmit.subscribe(res => {
      let arr = [];
      if (res.typ == 2 || res.typ == 4)
        res.table.forEach(x => {
          arr.push({ table: Object.values(x) });
        });
      else arr.push({ table: res.table });

      this.apiservice
        .setSaveSpezProject(this.anlSelected.ID, arr)
        .pipe()
        .subscribe((res: any) => {});
    });
  }

  public set data(dataIn: any) {
    this.projID.set(dataIn.data.selID);
    this.parentID.set(dataIn.data.parentID ?? -1);
    this.mode.set(dataIn.data.mode);
    if (dataIn.data.limitVon) {
      this.limitVon = dataIn.data.limitVon;
      this.limitBis = dataIn.data.limitBis;
      this.neuProjektFormGroup.controls.projektbeginn.setValue(new Date(this.limitVon).toISOString());
      this.neuProjektFormGroup.controls.projektende.setValue(new Date(this.limitBis).toISOString());
    }
    this.dataRefresh = dataIn.dataRefresh;
    this.neuProjektFormGroup.controls.ID.setValue(this.projID());
    this.neuProjektFormGroup.controls.parentID.setValue(this.parentID());
  }

  ngOnInit() {
    this.apiservice
      .getOpenProject(this.projID())
      .pipe()
      .subscribe((res: any) => {
        this.stammdaten = res.anl;
        this.history = res.hist;
        if (res.proj.rows.length > 0) {
          let proj = res.proj.rows[0];
          this.neuProjektFormGroup.controls.titel.setValue(proj.Title);
          this.neuProjektFormGroup.controls.verantwortlich.setValue(proj.Manager);
          this.neuProjektFormGroup.controls.kostenstelle.setValue(proj.Kostenstelle);
          this.neuProjektFormGroup.controls.projektbeginn.setValue(proj.ProjectStart);
          this.neuProjektFormGroup.controls.projektende.setValue(proj.ProjectEnde);
          this.neuProjektFormGroup.controls.projektstatus.setValue(proj.ProjectStatus);
          this.neuProjektFormGroup.controls.projektsumme.setValue(proj.Plankosten);
          this.neuProjektFormGroup.controls.kurztext.setValue(proj.K_Title);
          this.neuProjektFormGroup.controls.kostenstelle.setValue(proj.Kostenstelle);
          this.neuProjektFormGroup.controls.langtext.setValue(proj.L_Title ?? '');
          this.neuProjektFormGroup.controls.bemerkung.setValue(proj.Bemerkung ?? '');
          this.neuProjektFormGroup.controls.diagrammfarbe.setValue('#' + proj.ColorCode.toString(16).padStart(6, '0'));
          this.neuProjektFormGroup.controls.erledigt.setValue(proj.Erledigt ?? false);
          this.neuProjektFormGroup.controls.datum.setValue(proj.Erledigt_am ?? BackendLocaleDatePipe.today);
          this.neuProjektFormGroup.controls.lieferant.setValue(proj.Erledigt_durch);
          this.neuProjektFormGroup.controls.kosten.setValue(proj.Endkosten);
        }
        if (res.allproj.rows.length > 0) {
          this.verantwortliche = [...new Set<string>(res.allproj.rows.map(x => x.Manager))];
          this.kostenstellen = [...new Set<string>(res.allproj.rows.map(x => x.Kostenstelle))];
        }
      });
  }

  saveNewProject() {
    if (dayjs(this.neuProjektFormGroup.controls.projektbeginn.value).isBefore(this.limitVon, 'days'))
      return this.toastr.warning(
        this.mrTranslate.transform('Das Startdatum muss nach dem Startdatum des übergeordneten Projekts liegen.')
      );
    if (dayjs(this.neuProjektFormGroup.controls.projektende.value).isAfter(this.limitBis, 'days'))
      return this.toastr.warning(
        this.mrTranslate.transform('Das Enddatum muss vor dem Enddatum des übergeordneten Projekts liegen.')
      );
    if (dayjs(this.neuProjektFormGroup.controls.projektende.value).isBefore(this.limitVon, 'days'))
      return this.toastr.warning(
        this.mrTranslate.transform('Das Enddatum muss nach dem Startdatum des übergeordneten Projekts liegen.')
      );
    if (dayjs(this.neuProjektFormGroup.controls.projektbeginn.value).isAfter(this.limitBis, 'days'))
      return this.toastr.warning(
        this.mrTranslate.transform('Das Startdatum muss vor dem Enddatum des übergeordneten Projekts liegen.')
      );
    if (
      dayjs(this.neuProjektFormGroup.controls.projektbeginn.value).isAfter(
        this.neuProjektFormGroup.controls.projektende.value,
        'days'
      )
    )
      return this.toastr.warning(this.mrTranslate.transform('Das Startdatum kann nicht nach dem Enddatum liegen.'));

    this.clrForm().markAsTouched();
    this.neuProjektFormGroup.controls.anlagen.setValue(this.stammdaten.rows);
    if (this.neuProjektFormGroup.valid) {
      if (this.neuProjektFormGroup.value.erledigt) {
        this.apiservice
          .getProjektMaengel(this.projID())
          .pipe()
          .subscribe((res: any) => {
            this.maengel.set(res);
            this.showMangSelection = true;
          });
      } else {
        this.saveProject();
      }
    } else {
      return this.toastr.warning(
        this.mrTranslate.transform('Speichern abgebrochen. Bestimmte Felder sind nicht ausgefüllt. Bitte überprüfen!')
      );
    }
  }
  saveProject() {
    let body = this.neuProjektFormGroup.value;
    if (this.maengelselected().length > 0) {
      body.maengel = this.maengelselected();
    }
    this.apiservice
      .setSaveProject(body)
      .pipe()
      .subscribe((res: any) => {
        this.toastr.success(this.mrTranslate.transform('Projekt gespeichert'));
        this.dataRefresh.next(true);
        this.closedialog.next(true);
      });
  }

  openAnlagen() {
    this.apiservice
      .getKarteAnlagen(-1)
      .pipe()
      .subscribe((res: Table) => {
        this.showAnlSelection = true;
        //this.tableAnl.set(res);
        this.anlagen.set(res);
        this.selected.set(undefined);
      });
  }
  addAnlagen() {
    this.showAnlSelection = false;
    //this.stammdaten.rows = [];
    this.selected().forEach(sel => {
      this.stammdaten.rows.push({
        ID: -1,
        ProjectID: this.projID(),
        Typ: sel.OTYPID,
        StammID: sel.OSTAMMID,
        Bezeichnung: sel.typ + ' ' + sel.Bezirk + ' ' + sel.bezeichnung,
        StartMeter: sel.startmeter.toString() || sel.StartMeter,
        EndMeter: sel.endmeter.toString() || sel.EndMeter,
        ParentID: -1,
        NewSpez: '',
        UserName: sel.Username || sel.UserName,
        Status: BackendLocaleDatePipe.today,
      });
    });
  }

  removeAnlagen() {
    let x:any = {
      ID : this.anlSelected.ProjectID,
      stammID : this.anlSelected.StammID
    }
    this.apiservice
      .setDeleteProjectAnlage(x)
      .pipe()
      .subscribe((res: Table) => {
        this.stammdaten.rows = res.rows;
      });
  }

  changeAnlRow(event: any) {
    this.startmeter = event.StartMeter;
    this.endmeter = event.EndMeter;
  }
  changeMeter(obj: string, event: number) {
    obj == 'start' ? (this.anlSelected.StartMeter = event) : (this.anlSelected.EndMeter = event);
  }

  async createSpezifikationen() {
    let spezData: { columns: SpezColumnType[]; rows: SpezRowType[] } | SpezPointType[];
    switch (this.anlSelected.OTYPTYP) {
      case 1:
      case 3:
        spezData = (await firstValueFrom(
          this.apiservice.getSpez(this.anlSelected.StammID, this.anlSelected.Typ, this.anlSelected.OTYPTYP)
        )) as SpezPointType[];

        if (this.anlSelected['NewSpez'] != '') {
          let newSpezFields: string[] = this.anlSelected['NewSpez'].toString().split('\t');
          let fields: SpezPointType[] = [];
          let data: SpezPointType[] = spezData;
          newSpezFields.forEach(element => {
            let v: string[] = element.split('|');
            const fData = data.find(x => x.objekt == v[0]);
            if (fData) {
              fData.bezeichnung = v[1];
              fields.push(fData);
            } else {
              fields.push({
                objekt: v[0],
                bezeichnung: v[1],
                orgName: v.length > 2 ? v[2] : v[0],
                fieldType: 'str',
                sField: v[0],
                pflichtFeld: false,
                wListe: [],
              });
            }
          });
          spezData = fields;
        }
        break;
      case 2:
        break;
      case 4:
        spezData = (await firstValueFrom(
          this.apiservice.getSpez(-99, this.anlSelected.Typ, this.anlSelected.OTYPTYP) //Table ohne Rows anlegen
        )) as { columns: SpezColumnType[]; rows: SpezRowType[] };

        let newSpez: SpezRowType[] = [];

        if (this.anlSelected['NewSpez'] && this.anlSelected['NewSpez'] != '') {
          let newSpezRows: string[] = this.anlSelected['NewSpez'].toString().split('\r\n');
          newSpezRows.forEach(element => {
            let newSpezFields: string[] = element.split('\t');
            let fields: SpezRowType = {};
            newSpezFields.forEach(element => {
              let v: string[] = element.split('|');
              fields[v[0]] = {
                objekt: v[0],
                value: v[1],
                orgName: v.length > 2 ? v[2] : v[0],
              };
            });
            newSpez.push(fields);
          });
          spezData.rows = newSpez;
        }
        break;
    }

    this.overlayService.setOverlay({
      overlay: 'spezifikation',
      isTopOverlay: true,
      zIndex: 10,
      source: 'Projekt',
      tableSpez: objtype.isLine(this.anlSelected.OTYPTYP) ? spezData : [],
      spezData: objtype.isPoint(this.anlSelected.OTYPTYP) ? spezData : [],
      ostamm: this.anlSelected.StammID,
      otypid: this.anlSelected.Typ,
      type: this.anlSelected.OTYPTYP,
      stammData: {
        startmeter: this.anlSelected.StartMeter,
        endmeter: this.anlSelected.EndMeter,
      },
      dataRefresh: this.dataRefresh,
      returnEmitter: this.spezReturnEmit,
    });
  }

  colorFocusInput(input: HTMLInputElement) {
    input.focus();
    input.click();
  }

  selectedStatusChanged(event) {
    switch (this.neuProjektFormGroup.value.projektstatus) {
      case 1:
        this.neuProjektFormGroup.controls.diagrammfarbe.setValue('#90ee90');
        break;
      case 2:
        this.neuProjektFormGroup.controls.diagrammfarbe.setValue('#9acd32');
        break;
      case 3:
        this.neuProjektFormGroup.controls.diagrammfarbe.setValue('#b0c4de');
        break;
      case 4:
        this.neuProjektFormGroup.controls.diagrammfarbe.setValue('#ff8c00');
        break;
      case 5:
        this.neuProjektFormGroup.controls.diagrammfarbe.setValue('#008000');
        break;
    }
  }

  close() {
    setTimeout(() => {
      this.closedialog.next(true);
    });
  }
}
